import React, { FunctionComponent, SVGProps, useMemo, useState } from 'react'
import { Button } from '../../../../../../../../components/Button/Button'
import { AiFeature } from '../../../../../../../../models/AiFeature'
import { AiResult } from '../../../../../../../../models/AiResult'
import { Tooltip } from '../../../../../../../../components/Tooltip/Tooltip'
import { AddResultDefaultToCRMModal } from '../../../../../../../../views/MeetingSummary/CRM/V2/AddResultDefaultToCRMModal'
import { CUSTOM_PRESET_MAPPING, isAiFeatureClientAndAdvisorFollowUpTasks } from '../../../../CustomPresets/CustomPresetMapping'
import { useAppSelector } from '../../../../../../../../store/hooks'
import { selectCurrentUser } from '../../../../../../../../store/meetingSummary/user'

import './HeaderResultCRMButton.scss'
import { IntegrationServiceId, TASK_EXPORT_SUPPORTED_INTEGRATIONS } from '../../../../../../../../common/integrations'
import { formatDate } from '../../../../../common/aifeatures/utils'
import { IntegrationIcon } from '../../../../../../../../components/IntegrationIcon'

export interface HeaderResultCRMButtonProps {
  aiFeature: AiFeature
  aiResult: AiResult
  serviceId: IntegrationServiceId
}

export const HeaderResultCRMButton: React.FC<HeaderResultCRMButtonProps> = ({ aiFeature, aiResult, serviceId }) => {
  const currentUser = useAppSelector(selectCurrentUser)

  const { integrations: currentUserIntegrations } = currentUser ?? {}
  const { integrationInfos: aiFeatureIntegrations } = aiFeature

  const [show, setShow] = useState(false)

  const userHasIntegration = currentUserIntegrations?.some(({ serviceId: sId }) => serviceId === sId)
  const aiFeatureHasIntegration = aiFeatureIntegrations.some(({ serviceId: sId }) => serviceId === sId)
  const integrationIsTaskExportSupported = TASK_EXPORT_SUPPORTED_INTEGRATIONS.includes(serviceId as IntegrationServiceId)

  const _aiFeatureHasIntegration = isAiFeatureClientAndAdvisorFollowUpTasks(aiFeature) ? integrationIsTaskExportSupported : aiFeatureHasIntegration

  const serviceSyncStatus = useMemo(() => {
    return aiResult.syncStatus.filter((status) => status.serviceId === serviceId)
  }, [serviceId, aiResult])

  const getTooltipTitle = () => {
    const serviceIdLabel = serviceId[0].toUpperCase() + serviceId.slice(1)
    if (serviceSyncStatus.length > 0) {
      return `Saved '${aiFeature.name}' to ${serviceIdLabel} on ${formatDate(serviceSyncStatus[serviceSyncStatus.length - 1].syncedAt)}`
    }
    return `Save to ${serviceIdLabel}`
  }

  if (!userHasIntegration || !_aiFeatureHasIntegration) {
    return null
  }

  const { preset: { id: aiFeaturePresetId = '' } = {} } = aiFeature
  const CRMModal = CUSTOM_PRESET_MAPPING[aiFeaturePresetId]?.crmModal ?? AddResultDefaultToCRMModal
  return (
    <div className='d-none d-md-flex'>
      {show && <CRMModal aiFeature={aiFeature} result={aiResult} show={show} onHide={() => setShow(false)} serviceId={serviceId} />}
      <Tooltip className='paragraph-small' title={getTooltipTitle()} placement='top' offset={[0, 10]}>
        <Button className='px-2' variant='header' onClick={() => setShow((show) => !show)}>
          <div className='d-flex position-relative'>
            <IntegrationIcon serviceId={serviceId as IntegrationServiceId} className='crm-icon' fill='var(--zocks-gray-900)' />
            {serviceSyncStatus.length > 0 ? <i className='header-result-crm-synced-badge bi bi-circle-fill' /> : null}
          </div>
        </Button>
      </Tooltip>
    </div>
  )
}
